export default "__VITE_ASSET__qTVUpSnQ__"